module.exports = __webpack_public_path__ + "img/no-file.a491fc31.svg";